function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.50154 4.49936C4.50154 5.42745 4.87013 6.31752 5.52622 6.97378C6.18231 7.63004 7.07216 7.99872 8.00002 7.99872C8.92787 7.99872 9.81772 7.63004 10.4738 6.97378C11.1299 6.31752 11.4985 5.42745 11.4985 4.49936C11.4985 3.57127 11.1299 2.6812 10.4738 2.02494C9.81772 1.36868 8.92787 1 8.00002 1C7.07216 1 6.18231 1.36868 5.52622 2.02494C4.87013 2.6812 4.50154 3.57127 4.50154 4.49936ZM14 14C13.9923 10.6852 11.3091 8.00034 8.00002 8.00034C4.69095 8.00034 2.00766 10.6852 2 14H14Z",
  fill: "currentColor"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/stepCompleted.28881cb7.svg";
export { SvgComponent as ReactComponent };